var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.047 46.05a7 7 0 1 0 9.906 9.9 6.929 6.929 0 0 0 2-5.713 1 1 0 0 1 .286-.817L43.9 21.755a1 1 0 0 1 1.015-.244A10 10 0 0 0 57.9 10.593L52.387 16.1a3 3 0 0 1-3.306.634l-2.975-1.271a2.941 2.941 0 0 1-1.57-1.587l-1.274-2.957a3.011 3.011 0 0 1 .64-3.3L49.423 2.1a10.069 10.069 0 0 0-9.536 4.048A9.891 9.891 0 0 0 38.5 15.07a1 1 0 0 1-.243 1.019L10.587 43.76a.993.993 0 0 1-.818.287 6.954 6.954 0 0 0-5.722 2.003zm12.732-4.242L37.4 21.19a1 1 0 0 1 1.411 1.41L18.193 43.222a1 1 0 0 1-1.414-1.414zM13 51a4 4 0 1 1-4-4 4.005 4.005 0 0 1 4 4z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCle);
export default __webpack_public_path__ + "static/media/cle.611aaceb7f8646244dc6fcc93a9d64b1.svg";
export { ForwardRef as ReactComponent };